/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense } from 'react';
import MomentUtils from '@date-io/moment';
import { create } from 'jss';
import { ThemeProvider, StylesProvider, jssPreset } from '@material-ui/core';
import rtl from 'jss-rtl';
import theme from '../../theme';
import { useTranslation } from 'react-i18next';
// import { MainAppBarProvider } from "../../contexts/main-app-bar-context/MainAppBarProvider";
import Loading from '../../common/loading/Loading';
import Routes from './Routes';
import '../../i18n';
import AppLayout from './Layout';
import { useEffect } from 'react';
import axios from 'axios';
// import { getServicesApi } from '../../apis/services';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MianAppBar from '../main-app-bar/MianAppBar';
// import Fade from 'react-reveal/Fade';
// import { Helmet } from 'react-helmet';
import AOS from 'aos';
// import ContactPage from '../../pages/contact-page/ContactPage';
import { RegisterDataProvider } from '../../contexts/registerData-context/RegisterDataProvider';


axios.defaults.baseURL = 'https://websiteapi.fatoorah.sa/api';
// axios.defaults.baseURL = 'https://testclient-api.fatoorah.sa/api';

function App() {
  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

  const { i18n } = useTranslation();

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n.dir()]);

  useEffect(() => {
    AOS.init({
      duration: 1500
    });
  }, []);

  // const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  useEffect(() => {}, [i18n.language]);

  return (
    // <Fade>
    <>
      <div className={`app app-${i18n.dir()}`}>
        <ThemeProvider theme={theme(i18n.dir())}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <StylesProvider jss={jss}>
              <Suspense fallback={<Loading />}>
                <AppLayout>
                  <MianAppBar />
                  <RegisterDataProvider>
                    <Routes />
                  </RegisterDataProvider>
                  {/* <ContactPage /> */}
                </AppLayout>
              </Suspense>
            </StylesProvider>
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </div>
    </>
  );
}

export default App;
